<div>
	<div
		kendoTypography
		variant="h4"
		class="title">
		Safety Data Sheets
	</div>
	<div class="kendo-content">
		<kendo-grid
			kpaGrid
			id="grid_Sds_Search"
			#gridDataBinding="kpaODataBinding"
			[odataBinding]="sdsSearchService"
			[pageSize]="gridSettings.state.take"
			[skip]="gridSettings.state.skip"
			[filter]="gridSettings.state.filter"
			[sort]="gridSettings.state.sort"
			(dataStateChange)="dataStateChange($event)"
			[pageable]="true"
			(columnReorder)="onReorder($event)"
			(columnResize)="onResizeColumn($event)"
			(columnVisibilityChange)="onVisibilityChange($event)"
			(filterChange)="filterChange($event)"
			style="width: 100%"
			[filterable]="true"
			[sortable]="true"
			[reorderable]="true"
			[resizable]="true"
			[columnMenu]="{ filter: false, sort: false }"
			class="card card-grid kpa-grid">
			<kendo-grid-column
				*ngFor="let col of gridSettings.columnsConfig"
				[field]="col.field"
				[title]="col.title"
				[width]="col.width"
				[filter]="col.filter"
				[filterable]="col.filterable"
				[hidden]="col.hidden"
				[format]="col.format"
				[locked]="col.locked"
				class="col.class"
				[sortable]="col.sortable"
				[minResizableWidth]="col.minResizableWidth">
				<ng-template
					kendoGridFilterCellTemplate
					let-filter
					let-column="column">
					<div
						id="grid_SdsSearch_ProductName"
						*ngIf="col.field === 'ProductName'">
						<kendo-grid-string-filter-cell
							[column]="column"
							[filter]="filter"
							filterDelay="0"
							operator="contains"></kendo-grid-string-filter-cell>
					</div>
					<div
						id="grid_SdsSearch_CommonName"
						*ngIf="col.field === 'CommonName'">
						<kendo-grid-string-filter-cell
							[column]="column"
							[filter]="filter"
							filterDelay="0"
							operator="contains"></kendo-grid-string-filter-cell>
					</div>
					<div
						id="grid_SdsSearch_Manufacturer"
						*ngIf="col.field === 'Manufacturer'">
						<kendo-grid-string-filter-cell
							[column]="column"
							[filter]="filter"
							filterDelay="0"
							operator="contains"></kendo-grid-string-filter-cell>
					</div>
					<div
						id="grid_SdsSearch_Appearance"
						*ngIf="col.field === 'Appearance'">
						<kendo-grid-string-filter-cell
							[column]="column"
							[filter]="filter"
							filterDelay="0"
							operator="contains"></kendo-grid-string-filter-cell>
					</div>
					<div
						id="grid_SdsSearch_Keywords"
						*ngIf="col.field === 'Keywords'">
						<kendo-grid-string-filter-cell
							[column]="column"
							[filter]="filter"
							filterDelay="0"
							operator="contains"></kendo-grid-string-filter-cell>
					</div>
					<div
						id="grid_SdsSearch_LocationFilter"
						*ngIf="col.field === 'LocationId'">
						<my-dropdown-filter
							id="SdsSearch_location_filterCell"
							[filter]="filter"
							[data]="locations"
							textField="textField"
							valueField="LocationId">
						</my-dropdown-filter>
					</div>
				</ng-template>
				<ng-template
					kendoGridCellTemplate
					let-dataItem
					let-rowIndex="rowIndex"
					let-columnIndex="columnIndex">
					<div *ngIf="col.field === 'ProductName'">
						<span
							class="sds-productname"
							id="grid_SdsSearch_column_ProductName_r{{ rowIndex }}c{{ columnIndex }}"
							(click)="onSdsSelect(dataItem.Id, dataItem.FileId)">
							{{ dataItem.ProductName }}
						</span>
					</div>
					<div *ngIf="col.field === 'CommonName'">
						<span id="grid_SdsSearch_column_CommonName_r{{ rowIndex }}c{{ columnIndex }}">
							{{ dataItem.CommonName || '-' }}
						</span>
					</div>
					<div *ngIf="col.field === 'Manufacturer'">
						<span id="grid_SdsSearch_column_Manufacturer_r{{ rowIndex }}c{{ columnIndex }}">
							{{ dataItem.Manufacturer || '-' }}
						</span>
					</div>
					<div *ngIf="col.field === 'Appearance'">
						<div id="gridValue_SdsSearch_column_Appearance_r{{ rowIndex }}c{{ columnIndex }}">
							{{ dataItem.Appearance || '-' }}
						</div>
					</div>
					<div *ngIf="col.field === 'Keywords'">
						<div id="gridValue_SdsSearch_column_Keywords_r{{ rowIndex }}c{{ columnIndex }}">
							{{ dataItem.Keywords || '-' }}
						</div>
					</div>
					<div
						*ngIf="col.field === 'LocationId'"
						class="kpa-grid-cell-text-center">
						<div id="gridValue_SdsSearch_column_Location_r{{ rowIndex }}c{{ columnIndex }}">
							{{ dataItem.LocationName || '-' }}
						</div>
					</div>
				</ng-template>
			</kendo-grid-column>
			<ng-template kendoGridNoRecordsTemplate> {{ noDataFoundGridText }} </ng-template>
		</kendo-grid>
		<ng-template
			#template
			let-anchor>
			<span>{{ anchor.nativeElement.textContent }}</span>
		</ng-template>
	</div>
</div>

<kpa-view-sds
	[dialogOpened]="this.viewSds"
	[sdsDetails]="this.currentSdsDetails"
	[formatTypes]="formats"
	(closeDialog)="closeDialog()"></kpa-view-sds>
